import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import textUtils from '../common/utilities/TextUtils';
import apiCaller from "../../api/ApiCaller";
import { GENERIC_VALIDATION, ADD_UPDATE, getApiPath } from '../../api/ApiConst';
import { toast } from 'react-toastify';
import { ParameterOptionsKeyValues } from './ParameterOptionsList';
import { Validator } from '../constants/Validators';
import { parameterValidation } from '../common/utilities/Validations';

const ParameterValidationAddEdit = (props) => {
    const [validationOptionsKeyValue, setValidationOptionsKeyValue] = useState("")

    const validationTypeOptions = [
        { label: "Assert False", value: "ASSERT_FALSE" },
        { label: "Assert True", value: "ASSERT_TRUE" },
        { label: "Decimal Max", value: "DECIMAL_MAX" },
        { label: "Decimal Min", value: "DECIMAL_MIN" },
        { label: "Digits", value: "DIGITS" },
        { label: "Email", value: "EMAIL" },
        { label: "Future", value: "FUTURE" },
        { label: "Future Present", value: "FUTURE_PRESENT" },
        { label: "Max", value: "MAX" },
        { label: "Min", value: "MIN" },
        { label: "Negative", value: "NEGATIVE" },
        { label: "Negative Or Zero", value: "NEGATIVE_OR_ZERO" },
        { label: "Not Blank", value: "NOT_BLANK" },
        { label: "Null", value: "NULL" },
        { label: "Past", value: "PAST" },
        { label: "Past Or Present", value: "PAST_OR_PRESENT" },
        { label: "Pattern", value: "PATTERN" },
        { label: "Positive", value: "POSITIVE" },
        { label: "Positive Or Zero", value: "POSITIVE_OR_ZERO" },
        { label: "Size", value: "SIZE" },
        { label: "El Based", value: "EL_BASED " },
    ];
    const [validationObj, setValidationObj] = useState({
        id: "",
        name: "",
        description: "",
        message: "",
        type: "",
        requestParameterId: "",
        constraintValues: {},
    });
    const [validatorLabels, setValidatorLabels] = useState([]);
    const [validatorKeyValues, setValidatorKeyValues] = useState({})

    const [validationTypeKeyValue, setValidationTypeKeyValue] = useState("")

    const toggle = () => {
        props.close();
    }

    useEffect(() => {
        if (props.object != null) {

            let validatorObjData = {};
            setValidationObj(props.object)
            if (props.object.type !== "") {
                setValidationTypeKeyValue({ label: props.object.type, value: props.object.type })
            } else {
                setValidationTypeKeyValue("");
                setValidatorLabels([]);
            }
            if (props.object.type !== "" && (props.object.constraintValues)) {
                if (Object.keys(props.object?.constraintValues).length > 0) {
                    // setValidationObj({ ...props.object, constraintValues:  })
                }
                validatorObjData = props.object?.constraintValues;
                setValidatorLabels(Validator(props.object.type))
            }
        }
    }, [props.object]);

    useEffect(() => {
        if (props.parameterType) {
            setValidationOptionsKeyValue(ParameterOptionsKeyValues(props.parameterType))
        }
    }, [props.parameterType])

    //Text Change Event
    const handleTextChange = (e, type) => {
        if (type === "text") {
            setValidationObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            setValidationTypeKeyValue(e);
            setValidationObj(prev => ({ ...prev, type: e.value }))
            setValidatorLabels(Validator(e.value));
            let validatorObjData = {};
            let _validationObj = { ...validationObj };
            let validatorValues = Validator(e.value);
            if (validatorValues.length > 0) {
                validatorValues.map((data, index) => {
                    validatorObjData[data.name] = data.defaultValue;
                });
            } else {
                validatorValues = {};
            }
            _validationObj.constraintValues = validatorObjData;

            setValidatorKeyValues(validatorObjData);
            // setValidationObj(_validationObj);
            setValidationObj(prev => ({ ...prev, type: e.value, constraintValues: validatorObjData }))

        }
    }

    // Constrains Values Change Event 
    const handledConstraintValues = (e, type) => {
        if (type === "text" || type === "number") {
            setValidatorKeyValues(prev => ({ ...prev, [e.target.id]: e.target.value }));
            let _validationObj = { ...validationObj };
            _validationObj.constraintValues = { ...validatorKeyValues, [e.target.id]: e.target.value }
            setValidationObj(_validationObj);
        } else if (type === "checkbox") {
            setValidatorKeyValues(prev => ({ ...prev, [e.target.id]: e.target.checked }));
            let _validationObj = { ...validationObj };
            _validationObj.constraintValues = { ...validatorKeyValues, [e.target.id]: e.target.checked }
            setValidationObj(_validationObj);
        }
    }

    const handleCreateParameterValidation = () => {
        let requestObj = validationObj;
        if ((textUtils.isEmpty(requestObj.name, "Name", true)) ||
            (textUtils.isEmpty(requestObj.type, "Type", true)) ||
            (textUtils.isEmpty(requestObj.description, "Description", true)) ||
            (textUtils.isEmpty(requestObj.message, "Message", true))
        ) {
            return false;
        }

        if (Object.keys(requestObj.constraintValues).length > 0) {
            if (!(parameterValidation(requestObj.type, requestObj.constraintValues))) {
                return;
            }
        }
        let url = getApiPath(GENERIC_VALIDATION, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success(`Validation ${validationObj.id ? "Update" : "Created"} Successfully`);
            toggle();
            props.successCallBack();
        }, (error) => {
            // toast.error(error.response.data.message);
        })
    }


    return (
        <>
            <Modal show={props.show} onHide={toggle} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add Parameter Validation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-3">
                        <div className="col-lg-6">
                            <label>Name *</label>
                            <input type="text" className="form-control input-default"
                                id="name"
                                placeholder='Name'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={validationObj.name}
                            />
                        </div>
                        <div className="col-lg-6">
                            <label>Type *</label>
                            <Select
                                options={validationOptionsKeyValue}
                                value={validationTypeKeyValue}
                                id="type"
                                onChange={(e) => handleTextChange(e, "select")}
                                className="react-select-container"
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Description *</label>
                            <input type="text" className="form-control input-default"
                                id="description"
                                placeholder='Description'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={validationObj.description}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Message *</label>
                            <input type="text" className="form-control input-default"
                                id="message"
                                placeholder='Message'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={validationObj.message}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        {validatorLabels.length !== 0 &&
                            validatorLabels.map((data, index) =>
                                <div className={`col-lg-${data.size}`} key={index}>
                                    {data.type === "text" || data.type === "number" ?
                                        <>
                                            <label>{data.labelName} *</label>
                                            <input
                                                type={data.type}
                                                className="form-control input-default"
                                                id={(data.name)}
                                                placeholder={data.placeholder}
                                                onChange={(e) => handledConstraintValues(e, e.target.type)}
                                                value={validationObj.constraintValues[data?.name] ? validationObj.constraintValues[data?.name] : data.defaultValue}
                                            />
                                        </> : data.type === "checkbox" ? <>
                                            <input
                                                type={data.type}
                                                id={data.name}
                                                onChange={(e) => handledConstraintValues(e, e.target.type)}
                                                // checked={validationObj.constraintValues?.data?.name == true ? true : false}
                                                checked={validationObj.constraintValues?.data?.name ? validationObj.constraintValues?.data?.name : data.defaultValue}
                                            />
                                            <label className='ms-2'>{data.labelName}</label>
                                        </> : <></>
                                    }

                                </div>
                            )
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                        onClick={handleCreateParameterValidation}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ParameterValidationAddEdit